import { createAction, props } from "@ngrx/store";

import { Menu } from "@hermes/api-model-menu";

export const fetchMenu = createAction("[Menu] Fetch menu from Discovery");

export const fetchMenuSuccess = createAction(
    "[Menu] Fetch menu from discovery success",
    props<{ entry: Menu }>(),
);

export const fetchMenuFailure = createAction(
    "[Menu] Fetch menu from discovery failure",
    props<{ error: Error }>(),
);
